



















import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
@Component({
    name: 'PathTipPanel',
})
export default class PathTipPanel extends Vue {
    @Prop() public keywordTipListDatas: any;
    public  suggests: any[] = [];
    private loading: any = true;
    private aroundChecked = -1;


    constructor() {
        super();
    }

    public mounted() {
       this.watchDownUp();
    }

    @Watch('keywordTipListDatas', {deep: true})
    public handleResultData(val: any) {
        // debugger
        this.loading = false;
        if (val.baidu && val.baidu.pois  && val.baidu.pois.length) {
            this.suggests = val.baidu.pois;
        } else {
            this.suggests = [];
        }
    }



    public handleClickSearch(dataItem: any, dataIndex: any) {
        this.$emit('pathTipItemClick', dataItem);
    }

    private watchDownUp() {
        $(window).keydown((ev: any) => {
            const event = ev || window.event;
            // 上键
            if (event.keyCode === 38) {
                this.keyboardUp();
            }
            // 下键
            if (event.keyCode === 40) {
                this.keyboardDown();
            }
            if (event.keyCode === 13) {
            this.$emit('pathTipItemClick', this.suggests[this.aroundChecked]);
            this.aroundChecked = -1;
            }
        });
    }

    private keyboardUp() {
        const length = this.suggests.length;
        if (this.aroundChecked > 0) {
            this.aroundChecked --;
            this.$emit('pathTipItemClick', this.suggests[this.aroundChecked].name);
        } else {
            this.aroundChecked = length;
        }
    }
    private keyboardDown() {
        const length = this.suggests.length;

        if (this.aroundChecked < (length - 1)) {
            this.aroundChecked ++;
            this.$emit('pathTipItemClick', this.suggests[this.aroundChecked].name);
        } else {
            this.aroundChecked = -1;
        }
    }

}
